import MessagingThread from './MessagingThread';

export default MessagingThread;
